import React, { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { http } from "@/lib/api";
import { Card } from "@/components/Kit";

export default function SourcesHealth() {
  const [rows, setRows] = useState([]);
  useEffect(() => { http.get("/monitoring/sources").then((r) => setRows(r.data)); }, []);

  return (
    <div className="p-6 max-w-[1500px] mx-auto fade-up">
      <h1 className="font-display text-3xl font-bold text-[#A5300F]">Sources Health</h1>
      <p className="text-sm text-[#8A8175] mt-1 mb-4">Every monitoring data source, with commercial-use flag and licence note. Non-commercial feeds (Spamhaus, SSL Labs, VirusTotal) are deliberately excluded.</p>
      <Card>
        <table className="w-full text-sm" data-testid="sources-table">
          <thead><tr className="text-[11px] uppercase tracking-wider text-[#8A8175] text-left bg-[#FFF5EB] border-b border-[#ECE6DD]">
            <th className="py-2.5 px-4">Source</th><th>Type</th><th className="text-center">Status</th><th>Auth</th><th className="text-center">Commercial use</th><th>Licence note</th>
          </tr></thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.id} className="border-b border-[#F4EFE8] hover:bg-[#FBF7F1]" data-testid={`source-row-${s.id}`}>
                <td className="py-2.5 px-4 font-semibold">{s.source_name}</td>
                <td className="text-xs text-[#8A8175] uppercase">{s.source_type}</td>
                <td className="text-center">
                  {s.configured
                    ? <span className="inline-flex items-center gap-1 text-[#2E7D32] text-xs font-semibold"><CheckCircle2 className="w-3.5 h-3.5" />configured</span>
                    : <span className="inline-flex items-center gap-1 text-[#8A8175] text-xs font-semibold" data-testid={`not-configured-${s.id}`}><XCircle className="w-3.5 h-3.5" />not configured</span>}
                </td>
                <td className="text-xs text-[#8A8175]">{s.auth_mode}</td>
                <td className="text-center">{s.commercial_use_permitted ? <span className="text-[#2E7D32] text-xs font-bold">yes</span> : <span className="text-[#A5300F] text-xs font-bold">no</span>}</td>
                <td className="text-xs text-[#5C554C]">{s.licence_note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
